import RouteDropdown from 'components/RouteDropdown';
import React, { useState } from 'react';
import { addOrderToRoute, addOrdersToRoute } from 'services';
import { DATE_FORMATS, formatDate, showError, showSuccess } from 'utils';
import styles from './index.module.scss';

const AddOrderToRouteModal = props => {
  const [selectedRouteId, setSelectedRouteId] = useState<string>('');
  const [route, setRoute] = useState<Record<string, any>>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [routeSelected, setRouteSelected] = useState<boolean>(false);
  const { orderIds, onSuccess, toggleModal } = props;

  const addToRoute = async (e: React.FormEvent<EventTarget>) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (Array.isArray(orderIds)) {
        await addOrdersToRoute(selectedRouteId, orderIds);
      } else {
        await addOrderToRoute(selectedRouteId, orderIds);
      }
      await onSuccess();
      showSuccess('Selected order(s) added to Route successfully');
      toggleModal();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  const setRouteDetails = (route: Record<string, any>) => {
    const routeData = {
      id: route.objectId,
      name: route.name,
      deliveryDateTime: formatDate(route.deliveryDateTime?.iso, DATE_FORMATS.MM_DD_YYYY),
      locked: route.locked?.toString() || 'N/A',
    };
    setRoute(routeData);
  };

  const handleSelect = (id: string) => {
    setSelectedRouteId(id);
    setRouteSelected(true);
  };

  const RouteDetails = () => (
    <div className={styles['route-details']}>
      <div className={styles['route-info-group']}>
        <div className={styles['label']}>Route ID</div>
        <div className={styles['route-detail']}>{route.id}</div>
      </div>
      <div className={styles['route-info-group']}>
        <div className={styles['label']}>Route Name</div>
        <div className={styles['route-name']}>{route.name}</div>
      </div>
      <div className={styles['route-info-group']}>
        <div className={styles['label']}>Delivery Date</div>
        <div className={styles['route-name']}>{route.deliveryDateTime || 'N/A'}</div>
      </div>
      <div className={styles['route-v']}>
        <div className={styles['label']}>Locked</div>
        <div className={styles['route-name']}>{route.locked}</div>
      </div>
    </div>
  );

  return (
    <form onSubmit={addToRoute} className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>Order</div>
            <div className={styles['modal-title']}>Add Order to Route</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <div>
            <div className={styles['label']}>Route</div>
            <RouteDropdown
              disabled={loading}
              selectedRoute={selectedRouteId}
              setRouteDetails={setRouteDetails}
              setSelectedRoute={handleSelect}
            />
          </div>
          {routeSelected && <RouteDetails />}
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            onClick={toggleModal}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type={'submit'}
            className={styles['submit-button']}
            disabled={loading}
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  );
};

export default AddOrderToRouteModal;
